import { render, staticRenderFns } from "./contact-persons.vue?vue&type=template&id=57f3510d&"
import script from "./contact-persons.vue?vue&type=script&lang=js&"
export * from "./contact-persons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports